import { createContext, Suspense, useContext, type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { type ModuleSpec } from '../modules';
import { route as defaultMissionsRoute } from '../modules/einsaetze/config';
import { TrackingContextProvider } from '../tracking';
import ModuleLoader from './ModuleLoader';

export type ModuleContext = Pick<ModuleSpec, 'id' | 'label' | 'icon' | 'trackingContext' | 'supportsMissions' | 'route'>;

const Context = createContext<ModuleContext | undefined>(undefined);

export default function ModuleContextProvider({ children, ...props }: PropsWithChildren<ModuleContext>) {
  return (
    <Context.Provider value={props}>
      <TrackingContextProvider category={props.trackingContext}>
        <Suspense fallback={<ModuleLoader />}>{children}</Suspense>
      </TrackingContextProvider>
    </Context.Provider>
  );
}

export function useModule() {
  return useContext(Context);
}

export function useMissionsRoute(): string {
  const module = useModule();
  return (module?.supportsMissions ? module.route : undefined) ?? defaultMissionsRoute;
}

export function useModuleTranslation() {
  return useTranslation(useModule()?.id);
}
